import React from 'react';
import ReactApexChart from 'react-apexcharts';

interface Props {
  title: string;
  loading: boolean;
  empty: boolean;
  emptyMessage?: string;
  options: any;
  series: any;
  type: 'line' | 'area' | 'bar' | 'donut' | 'radialBar';
  height?: number;
}

/**
 * Wrapper genérico para las gráficas de ApexCharts (ya es una dependencia
 * del proyecto -- se reutiliza en vez de meter una librería nueva). Maneja
 * el estado de carga y el mensaje vacío para no repetirlo en cada sección.
 */
const ChartCard = ({
  title,
  loading,
  empty,
  emptyMessage,
  options,
  series,
  type,
  height = 260,
}: Props) => {
  return (
    <div className='chart-card'>
      <p className='chart-title'>{title}</p>
      <div className={`chart-body ${loading || empty ? 'is-placeholder' : ''}`} style={{ height }}>
        {loading ? (
          <div className='chart-loading'>Cargando...</div>
        ) : empty ? (
          <div className='chart-empty'>{emptyMessage || 'Sin datos para este rango'}</div>
        ) : (
          <ReactApexChart
            options={options}
            series={series}
            type={type}
            height={height}
            width='100%'
          />
        )}
      </div>
    </div>
  );
};

export default ChartCard;
